
import api from "../../../../../api/api"


const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
      console.log(str)
    return str.join("&");
}

const getGSTR1Summary = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/gst-report/gstr1/summary?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getGSTR1Json = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/gst-report/gstr1/json?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const getGSTR2Summary = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/gst-report/gstr2/summary?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getGSTR2Json = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/gst-report/gstr2/json?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getGSTR3BSummary = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/gst-report/gstr3b/summary?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getGSTR3BJson = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/gst-report/gstr3b/json?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}





const gstReportServices = {
    getGSTR1Summary,
    getGSTR1Json,

    getGSTR2Summary,
    getGSTR2Json,
    
    getGSTR3BSummary,
    getGSTR3BJson
    
}
export default gstReportServices;